import { Component, Input, OnDestroy, type OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { EPolicyTypes, IPolicyAsset, IPolicyDetail } from 'src/app/modules/shared/models/policy.model';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { PolicyService } from '../../../policy/policy.service';
import { single_step_branch_form_keys } from './single-step-branch-switch.constants';
import { Subject } from 'rxjs';
import { EProductType, UNIT_PRODUCTS } from '../../athora.constants';

@Component({
  selector: 'app-single-step-branch-switch',
  templateUrl: './single-step-branch-switch.component.html',
  styleUrl: './single-step-branch-switch.component.scss',
})
export class SingleStepBranchSwitchComponent implements OnInit, OnDestroy {

  @Input() form: FormGroup;
  @Input('assets')
  set _assets(val: IPolicyAsset[]) {
    if (val && val.length > 0) {
      this.manageFunds(val);
    }
  }
  assets: IPolicyAsset[] = [];
  keys: IFormKey[] = CommonUtils.assign(single_step_branch_form_keys);
  actualInvestmentLine = '';
  destroy$ = new Subject();

  constructor(
    private readonly _policyService: PolicyService
  ) { }

  ngOnInit(): void {
  }

  get lineFormKey(): IFormKey {
    return this.keys.find(x => x.controlName === 'line');
  }

  get currentRisk(): string {
    const code = (this._policyService.policyType === EPolicyTypes.MULTIRAMO) ? 
      this._policyService.policyDetail.summary.currentRisk : 
      this._policyService.policyDetail.policyExtraInfo.lineCode;
    return code;
  }

  get productCode(): string {
    return this._policyService.productCode;
  }

  get isUnitProduct(): boolean {
    return UNIT_PRODUCTS.includes(EProductType[this.productCode]);
  }

  manageFunds(assets: IPolicyAsset[]) {
    const isMultiramo = this._policyService.policyType === EPolicyTypes.MULTIRAMO;
    const actualAsset = assets.find(x => isMultiramo ? x.fundCode === this.currentRisk : x.lineCode === this.currentRisk);
    this.actualInvestmentLine = actualAsset?.attributeDescription + (this.isUnitProduct ? ' - ' + actualAsset.lineDescription : '') || null;
    const otherAssets = assets.filter(x => isMultiramo ? x.fundCode !== this.currentRisk : x.lineCode !== this.currentRisk);
    this.lineFormKey.options = otherAssets.map(x => ({ 
      key: x.lineCode, 
      value: x.attributeDescription + (this.isUnitProduct ? ' - ' + x.lineDescription : '')
    }));
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
